import { create } from 'zustand';

const modalKey = (name) => `show${name.charAt(0).toUpperCase()}${name.slice(1)}`;

const useModalStore = create((set) => ({
    showSickModal: false,
    showTimeOffModal: false,
    showCompedServiceModal: false,
    showPaySummaryModal: false,
    showEarningsModal: false,
    showAddEventModal: false,
    showEditEventModal: false,
    showEventListModal: false,
    showToDoListModal: false,
    showReviewNotesModal: false,
    showDaySmartAuthModal: false,
    showTicketListModal: false,
    showSplitTipCalculatorModal: false,
    showRunPayrollModal: false,
    showComparisonGraphModal: false,
    showEsstReportModal: false,
    showDailySummaryModal: false,
    showBusinessTrendsModal: false,
    showEmployeeComparisonModal: false,
    showHandbookModal: false,
    showAddEmployeeModal: false,
    showSeeScheduleModal: false,

    modalProps: {},

    openModal: (name, props = {}) => set((state) => {
        const updatedProps = { ...state.modalProps, [name]: props };
        return {
            modalProps: updatedProps,
            [modalKey(name)]: true,
        };
    }),


    closeModal: (name) => set((state) => ({
        [modalKey(name)]: false,
        modalProps: { ...state.modalProps, [name]: undefined }, // clean up
    })),

    closeAllModals: () =>
        set({
            showSickModal: false,
            showTimeOffModal: false,
            showCompedServiceModal: false,
            showPaySummaryModal: false,
            showEarningsModal: false,
            showAddEventModal: false,
            showEditEventModal: false,
            showEventListModal: false,
            showToDoListModal: false,
            showReviewNotesModal: false,
            showSplitTipCalculatorModal: false,
            showRunPayrollModal: false,
            showComparisonGraphModal: false,
            showEsstReportModal: false,
            showEmployeeComparisonModal: false,
            showHandbookModal: false,
            showAddEmployeeModal: false,
            showSeeScheduleModal: false,
            modalProps: {},
        }),
}));

export default useModalStore;
